interface Props {
  size?: number;
  className?: string;
}

const LOGO_SRC = '/BCO.69c8c5c1-594a-416a-a73f-3e2625764f45.png';

/** KidWise owl mascot — uses the official brand PNG */
export default function AppLogo({ size = 64, className = '' }: Props) {
  return (
    <img
      src={LOGO_SRC}
      width={size}
      height={size}
      alt="KidWise owl mascot"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

// Named export alias for clarity
export { AppLogo };
